<script setup lang="ts">
import {ProgressSpinner} from "../Library";

defineOptions({
    inheritAttrs: false,
});
</script>
<template>
    <div class="-h-full -grow flex items-center justify-center">
        <div class="flex w-28 items-center justify-center" v-bind="$attrs">
            <ProgressSpinner class="aspect-square h-full w-full" />
        </div>
    </div>
</template>
<style scoped></style>
